export { default } from "./deepmerge.mjs";
export * from "./deepmerge.mjs";